<template>
  <div class="timepicker">
    <div class="element">
      <select v-model="hour">
        <option v-for="n in 12" :value="n | zerofy" :key="n">
          {{ n | zerofy }}
        </option>
      </select>
    </div>
    <span>:</span>
    <div class="element">
      <select v-model="min">
        <option v-for="n in 60" :value="(n - 1) | zerofy" :key="n">
          {{ (n - 1) | zerofy }}
        </option>
      </select>
    </div>
    <div class="element period">
      <select v-model="period">
        <option value="am">AM</option>
        <option value="pm">PM</option>
      </select>
    </div>
  </div>
</template>
<script>
export default {
  name: "TimeInput",
  props: {
    value: {
      type: String,
      default: "12:00 am"
    }
  },
  data() {
    return {
      hour: "",
      min: "",
      period: ""
    };
  },
  mounted() {
    const [timeString, period] = this.value.split(" ");
    const [hour, min] = timeString.split(":");
    this.period = period.trim();
    this.hour = hour;
    this.min = min;
    this.$emit("input", this.value);
  },
  filters: {
    zerofy(number) {
      if (number < 10) number = "0" + number;
      return number;
    }
  },
  watch: {
    hour(val) {
      this.$emit("input", val + ":" + this.min + " " + this.period);
    },
    min(val) {
      this.$emit("input", this.hour + ":" + val + " " + this.period);
    },
    period(val) {
      this.$emit("input", this.hour + ":" + this.min + " " + val);
    }
  }
};
</script>
<style lang="scss" scoped>
.timepicker {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 13px 7px;
  color: #b1afcd;
  background: #100e2a;
  border: 1px solid #312f62;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 5px;
  margin-left: 10px;
  .element {
    display: flex;
    select {
      margin-top: 0;
      padding: 0;
      padding-left: 5px;
      color: #b1afcd;
      background: #100e2a;
      border: 0;
      text-align: right;
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;
      border: none;
      background-image: url("https://artisthub-user-content.nyc3.digitaloceanspaces.com/images/fe93e0b2-09e6-4fc1-b829-b8c340e8643c.png");
      background-size: 12px 12px;
      background-repeat: no-repeat;
      background-position: right center;
      padding: 2px 15px 2px 2px;
    }
  }
  .period {
    margin-left: 5px;
    margin-right: 3px;
  }
  span {
    margin-left: 7px;
    margin-right: 5px;
    color: #b1afcd;
  }
}
</style>
